import { colors } from "./color"

export const customStyles = {
    control: (base, state) => ({
        ...base,
        backgroundColor: colors.backgrond,
        padding: "5px",
        border: "2px solid " + colors.primary,
        borderRadius: "8px",
        boxShadow: "none",
        cursor: "pointer",
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected
            ? colors.primary
            : state.isFocused
            ? colors.secondary
            : "black",
        color: colors.textColor,
        padding: "10px",
        borderRadius: "30px",
        cursor: "pointer",
    }),
    menu: (base, state) => ({
        ...base,
        borderRadius: "8px",
        overflow: "hidden",
        backgroundColor: "black",
        color: colors.textColor,
        padding: "0 4px",
        textAlign: "center",
    }),
}

export const episodesCustomStyles = {
    control: (base, state) => ({
        ...base,
        fontSize: "1em",
        backgroundColor: colors.primary,
        padding: "5px",
        border: "none",
        borderRadius: "8px",
        boxShadow: "none",
        cursor: "pointer",
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected
            ? colors.primary
            : state.isFocused
            ? colors.secondary
            : "black",
        color: colors.textColor,
        padding: "5px",
        borderRadius: "30px",
        cursor: "pointer",
    }),
    menu: (base) => ({
        ...base,
        borderRadius: "8px",
        maxHeight: "none",
        overflow: "hidden",
        backgroundColor: "black",
        color: colors.textColor,
        padding: "0 4px",
        textAlign: "center",
    }),
}

export const customTheme = (theme) => ({
    ...theme,
    borderRadius: 0,
    colors: colors.textColor,
    border: "none",
})
